import _ from 'lodash'
import moment from 'moment/moment'

export function call_func_if_exists(func, arg){
    // currently accepts only a single argument...
    if(_.isFunction(func)){
        func(arg)
    }
}
export function refresh_page(){
    window.location.reload(true)
}

export function order_date_format(date){
    return moment(date).format('MMM DD, YYYY h:mm a')
}

export function order_date_format_array(date){
    date = moment(date)
    return [ date.format('MMM DD, YYYY'), date.format('h:mm a') ]
}

export function ship_date_format(date){
   return moment(date).format('ddd MMM DD, YYYY')
}

export function ups_ship_time_format(date){
   date = String(date)
   let hour = date.substring(0,2)
   let min = date.substring(2,4)
   let sec = date.substring(4)

   var period = 'AM'
   if( hour > 12 ){
    hour = Number(hour) - 12
    period = 'PM'
   }

   return `${hour}:${min} ${period}`
}

export function preload_image(src, onload, onerror){
    if(!onload){
        onload = (e) => {}
    }
    if(!onerror){
        onerror = (e) => { console.error('IMAGE NOT FOUND: ' + src)}
    }
    async( function preload(){
        let img = new Image()
        img.onload = onload
        img.onerror = onerror
        img.src = src
    })
}

export function check_image(src){
    return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = e => resolve(src)
        img.onerror = e => reject(new Error(`${src} does not exist.`))
        img.src = src
    })
}

// Device Check
export function is_device_mobile(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
     return true;
    }
}

// Async
export function async(fn){
    setTimeout(fn, 0)
}

export function async_promise(fn){
    return new Promise( (resolve, reject) => {
        setTimeout(function(){
            let result = fn()
            resolve( result )
        }, 0);
    })
}

// Object stuff
export function bind_methods_to_self(obj){
    let properties = Object.getOwnPropertyNames(obj)
    properties.forEach( property => {
        if( _.isFunction(obj[property]) ){
            obj[property] = obj[property].bind(obj)
        }
    })
}

// Arrays
export function max(arr){
    if( !_.isArray(arr) ){
        throw new TypeError('max: invalid parameter passed. arr=' + arr + ' array? ' + _.isArray(arr) )
    }
    if( arr.length === 0 ){
        throw new RangeError('max: array is empty')
    }
    return Math.max.apply(null, arr)
}
export function min(arr){
    if( !_.isArray(arr) ){
        throw new TypeError('min: invalid parameter passed. arr=' + arr)
    }
    if( arr.length === 0 ){
        throw new RangeError('min: array is empty arr=' + arr)
    }
    return Math.min.apply(null, arr)
}

export function adjacent(arr1, arr2){
    return (max(arr1) + 1) === min(arr2)
}

export function sort_ascending(a,b){
    return a - b
}
export function sort_descending(a,b){
    return b - a
}
export function sort(arr, type='asc'){
    if( _.isNumber(arr[0]) ){
        switch(type){
            case 'asc':
                return arr.sort( sort_ascending )
            case 'desc':
                return arr.sort( sort_descending )
            default:
                return arr.sort( sort_ascending )
        }
    }else{
        return arr.sort()
    }
}

// Functions
export function datetime(value){
    var d = moment(value);
    var date = d.format('MMM DD, YYYY')
    var time = d.format('h:mm:ss a')
    return {
        date,
        time
    }
}
export function format_phone(txt) {
    var numbers = txt.replace(/\D/g, ''),
        char = {0:'(',3:') ',6:' - '};
    txt = '';
    for (var i = 0; i < numbers.length; i++) {
        txt += (char[i]||'') + numbers[i];
    }
    return txt
}

export function to_milliseconds(num, measure){
    measure = plural( upper(measure) )
    if( !_.isNumber(num) ){
        throw new TypeError('to_milliseconds needs a numerical value to convert')
    }
    switch(measure){
        case 'MINUTES':
            return num*60*1000
        case 'SECONDS':
            return num*1000
        case 'HOURS':
            return num*60*60*1000
        default:
            return num*1000
    }
}

export function currency(amount) {
    return '$' + Number(amount).toFixed(2)
}

export function wheel_offset(value){
    return ( value >= 0 ? '+' : '-' ) + value
}

// Cookies
export function set_cookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = 'expires='+d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; expires=' + expires + '; path=/;';
    //console.log(document.cookie)
}

export function get_cookie(cname) {
    let name = cname + '=';
    let cookies = document.cookie.split(';');
    for(let i=0; i<cookies.length; i++) {
        let c = cookies[i];
        while (c.charAt(0)===' ') c = c.substring(1);
        if (c.indexOf(name) === 0){
            return c.substring(name.length,c.length);
        }
    }
    return null;
}

export function delete_cookie(cname) {
    set_cookie(cname, '', -100);
}

// Numbers
export let invalid_number = function(num) {
    return _.isNaN(num) || !_.isFinite(num) || !_.isNumber(num)
}

export let valid_number = function(num){
    return !invalid_number(num)
}

// Strings
export function upper(str) {
    return str ? String(str).toUpperCase() : ''
}

export function lower(str) {
    return str ? String(str).toLowerCase() : ''
}

export function proper(str){
    if(str){
        str = lower(str)
        let result = ''
        _.words(str).forEach( (word, index) => {
            if( index !== 0 ){
                result += ' '
            }
            result += _.upperFirst(word)
        })
        return result
    }else{
        return ''
    }
}

export function is_upper(str) {
    return String(str) === upper(str)
}

export function is_lower(str) {
    return String(str) === upper(str)
}

export function same_case(ref, str) {
    if( is_upper(ref) ){
        return upper(str)
    }else{
        return lower(str)
    }
}

export function plural(str) {
    str = String(str)
    let last_letter = str[str.length-1]
    let is_singular = upper(last_letter) !== 'S'
    if( is_singular ){
        return str + same_case(last_letter, 'S')
    }else{
        return str
    }
}

export function escape_reg_exp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export function css_class(str) {
    return String(str).toLowerCase().trim().replace(/ /g,'-').replace(/#/g,'');
}

export function send_notification(title, msg){
    if ('Notification' in window) {
        let Notification = window.Notification
        var notification = new Notification(title, {
            body: msg
        });
        setTimeout(notification.close.bind(Notification), 4000);
    }
}
